import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  padding: 16px 16px 16px 49px;
  border-top: 1px solid ${({theme}) => `
    ${theme.variables.borderColor};
  `};
`;
